import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { fadeUpAnimation } from '../post-details-pop-up/animations';
import { FormControl } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
import { DoctorSocialService } from '../doctor-social.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { FeedOptionsDialogComponent } from '../feed-options-dialog/feed-options-dialog.component';
import { OthersFeedOptionsDialogComponent } from '../others-feed-options-dialog/others-feed-options-dialog.component';
import { LikesListDialogComponent } from '../likes-list-dialog/likes-list-dialog.component';
import { LoginDialogComponent } from 'src/app/patients/doctor-profile/components/login-dialog/login-dialog.component';
import { OptionsForModComponent } from '../options-for-mod/options-for-mod.component';

@Component({
  selector: 'app-post-details-com',
  templateUrl: './post-details-com.component.html',
  styleUrls: ['./post-details-com.component.css'],
  animations: [fadeUpAnimation]
})
export class PostDetailsComComponent implements OnInit {

  postDetails
  mediaExists: boolean = false
  Comments;

  postId;

  mainComment = new FormControl("");

  postStatusForDialogClose = null

  slideConfigureForDoctor = {
    dots: false,
    autoplay: false,
    infinite: false,
    variableWidth: false,
    draggable: false,
    rtl: false,
    arrows: true,
    slidesToShow: 1,
  };

  @ViewChild('mainCommentsScroll', { static: false }) mainCommentsScroll: ElementRef;

  constructor(
    private dialog: MatDialog,
    private service: DoctorSocialService,
    private toaster: ToastrService,
    public app: AppService,
    private route: ActivatedRoute,
    private Router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.postId = this?.route?.snapshot?.paramMap?.get('feedId')
    this.slideConfig();
    this.getPostById();
  }

  getPostById() {
    this.service.getPostById(this.postId).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.postDetails = res?.data
          this?.app?.isMostlyEnglish(this.postDetails?.postText) == true ? this.postDetails.textDirection = "ltr" : this.postDetails.textDirection = "rtl"

          if (isPlatformBrowser(this.platformId)) {
            if (res?.data?.postMedia) {
              this.mediaExists = true
            }
            // if (res?.data?.postMedia?.length != 0 && this?.data?.index && this?.data?.index != 0) {
            //   this.reorderMediaIndex();
            // }
            // this.addParamsToUrl();

            if (this.app.getUserData()) {
              this.getMainComments(3, 1)
            }

            if (res?.data?.postMedia?.length != 0 && res?.data?.postMedia[0]?.mediaType == 3) {
              this.urlChangeInput();
            }
          }


        } else if (res.errorCode != 0) {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.error("Something went wrong");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.error("حدث خطأ ما");
          }
          // this.cancel();
        }
      }
    )
  }

  mainCommentsTotalRow = 0
  getMainComments(pageSize: number, pageNumber: number) {
    this.service.getMainComments(this.postDetails.postId, pageSize, pageNumber).subscribe(
      res => {
        this.mainCommentsTotalRow = res?.data?.totalRows
        this.Comments = res?.data?.data
      }
    )
  }

  showMoreMainComments(pageSize: number) {
    if (this?.Comments?.length >= this?.mainCommentsTotalRow) { return }
    // this.service.getMainComments(this?.postDetails?.postId, pageSize, 1).subscribe(
    //   res => {
    //     const newArray = res?.data?.data.slice(0.3)
    //     this.mainCommentsTotalRow = res?.data?.totalRows
    //     newArray?.forEach(element => {
    //       this.Comments.push(element)
    //     });
    //   }
    // )
    this.getMainComments(pageSize, 1)
    setTimeout(() => {
      this.scrollDownMainComments();
    }, 700);
  }

  showMoreSubComments(subCommentsLength, commentsCount, commentId, index) {
    if (subCommentsLength >= commentsCount) { return }

    // ${CommentId}/${pageSize}/${pageNumber}
    this.service.getSubComments(commentId, subCommentsLength + 3, 1).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.Comments[index].subComments = res?.data?.data
          // this.Comments[index].commentsCount = this?.Comments[index]?.subComments?.length 
        } else {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.error("Something went wrong");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.error("حدث خطأ ما");
          }
        }
      }
    )
    // this.getMainComments(pageSize, 1)
    // setTimeout(() => {
    //   this.scrollDownMainComments();
    // }, 700);
  }

  deleteComment(commentId, index, type, deepIndex) {
    this.service.deleteComment(commentId).subscribe(
      res => {
        if (res.errorCode == 0) {
          if (type == 'surface') {
            this.Comments.splice(index, 1);
            this.postDetails.commentsCount = this?.postDetails?.commentsCount - 1
            this.mainCommentsTotalRow = this?.mainCommentsTotalRow - 1
            this.postStatusForDialogClose = "like"
          } else if (type == 'deep') {
            this.Comments[index].subComments.splice(deepIndex, 1);
            this.Comments[index].commentsCount = this.Comments[index].commentsCount - 1

            if (this.Comments[index].subComments.length == 0) {
              this.Comments[index].hasComments == false
            }
            // this.Comments[index].commentsCount = this.Comments[index].commentsCount + 1
            // this.Comments[index].hasComments = true
          }

          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.success("Deleted Successfully");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.success("تم الحذف بنجاح");
          }
        } else {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.error("Something went wrong");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.error("حدث خطأ ما");
          }
        }
      }
    )

  }

  replyToComment(index) {
    // ShowAndHideInputForSubComment
    if (!this.Comments[index].writeSubComment) {
      this.Comments[index].writeSubComment = true
    } else {
      this.Comments[index].writeSubComment = false
    }
  }

  subCommentsDialog(comment) {
    return
    // let req = {
    //   commentId: comment?.commentId,
    //   commentText: comment?.commentText,
    //   commentedByName: comment?.commentedByName,
    //   commentedByPicture: comment?.commentedByPicture,
    // }
    // const dialogRef = this.dialog.open(SubCommentsDialogComponent, {
    //   width: '470px',
    //   data: req
    // });
    // dialogRef.afterClosed().subscribe(res => {
    // });
  }

  // reorderMediaIndex() {
  //   const elementToMove = this.postDetails.postMedia.splice(this?.data?.index, 1)[0];
  //   this.postDetails.postMedia.unshift(elementToMove);
  // }

  likeDislikePost(postId, likeStatus) {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (likeStatus == false) {
      this.service.likePost(postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            this.postDetails.likesCount = this?.postDetails?.likesCount + 1
            this.postDetails.iLikedPost = true
            this.postStatusForDialogClose = "like"
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    } else if (likeStatus == true) {
      this.service.unlikePost(postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            this.postDetails.likesCount = this?.postDetails?.likesCount - 1
            this.postDetails.iLikedPost = false
            this.postStatusForDialogClose = "like"
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    }
  }

  sendMainComment() {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (!this.mainComment.value) { return }
    this.scrollTopMainComments();
    let request = new FormData();
    request.append("CommentText", this?.mainComment?.value);
    // request.append("CommentId", null);
    this.service.sendComment(request, this?.postDetails?.postId).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.Comments.unshift(res?.data)
          this.mainComment.setValue('')
          this.mainCommentsTotalRow = this.mainCommentsTotalRow + 1
          this.postDetails.commentsCount = this.postDetails.commentsCount + 1
          this.postStatusForDialogClose = "like"
          // setTimeout(() => {
          //   this.scrollTopMainComments();
          // }, 400);
        } else {
          this.toaster.error(res.errorMessage);
        }
      }
    )
  }

  sendSubComment(commentId, textValue, index) {
    if (textValue?.length == 0) { return }
    this.Comments[index].writeSubComment = false
    let request = new FormData();
    request.append("CommentText", textValue);
    request.append("CommentId", commentId);
    this.service.sendComment(request, this?.postDetails?.postId).subscribe(
      res => {
        if (res.errorCode == 0) {
          if (this.Comments[index].hasComments == true) {
            this?.Comments[index]?.subComments?.unshift(res?.data)
          } else {
            this.Comments[index].subComments = []
            this?.Comments[index]?.subComments?.push(res?.data)
          }
          this.Comments[index].commentsCount = this.Comments[index].commentsCount + 1
          this.Comments[index].hasComments = true
        } else {
          this.toaster.error(res.errorMessage);
        }
      }
    )
  }

  showAllSubComments(index, commentCount) {
    // comment?.showSubComments == true
    if (!this.Comments[index].showSubComments && commentCount > 1) {
      this.Comments[index].showSubComments = true
    }
  }

  cancel(): void {
    this.Router.navigate(['/' + this?.app?.languageCode + '/Tebgram/activity'])
    // this.removeParamsFromUrl();
    // setTimeout(() => {
    //   this.dialogRef.close(this.postStatusForDialogClose);
    // }, 100);
  }

  editPostPopUp(id, isMyPost) {
    if (this?.app?.IsSocialMediaManager) {
      const dialogRef = this.dialog.open(OptionsForModComponent, {
        width: '390px',
        data: id,
        panelClass: 'option-dialog',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res == "delete") {
          this.postStatusForDialogClose = "delete"
          this.cancel();
        } else if (res == "edit") {
          this.getPostById();
          this.postStatusForDialogClose = "edit"
          // this.cancel();
        }
      });
    } else {
      if (isMyPost == true) {
        const dialogRef = this.dialog.open(FeedOptionsDialogComponent, {
          width: '390px',
          data: id,
          panelClass: 'option-dialog',
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(res => {
          if (res == "delete") {
            this.postStatusForDialogClose = "delete"
            this.cancel();
          } else if (res == "edit") {
            this.getPostById();
            this.postStatusForDialogClose = "edit"
            // this.cancel();
          }
        });
      } else {
        const dialogRef = this.dialog.open(OthersFeedOptionsDialogComponent, {
          width: '600px',
          data: id,
          panelClass: 'option-dialog',
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(res => {
          if (res == 'save') {
            this.postDetails.iSavedPost = true
          } else if (res == 'unsave') {
            this.postDetails.iSavedPost = false
          }
          this.postStatusForDialogClose = "saved"
        });
      }
    }

  }

  savePost() {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (!this?.postDetails?.iSavedPost) {
      this.service.savePost(this?.postDetails?.postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Saved Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم الحفظ");
            }
            this.postDetails.iSavedPost = true
            this.postStatusForDialogClose = "saved"
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    } else if (this?.postDetails?.iSavedPost) {
      this.service.unSavePost(this?.postDetails?.postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Unsaved Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم إلغاء الحفظ");
            }
            this.postDetails.iSavedPost = false
            this.postStatusForDialogClose = "saved"
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    }
  }

  likesPopUp(id, likeCount, type) {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (likeCount == 0) { return }
    let req = {
      id: id,
      type: type,
    }
    const dialogRef = this.dialog.open(LikesListDialogComponent, {
      width: '470px',
      data: req
    });
    dialogRef.afterClosed().subscribe(res => {
    });
  }

  commentsPopUp() {

  }

  chartPopUp() {

  }

  likePost() {

  }

  likeDislikeComment(likeStatus, commentId, index, type, deepIndex) {
    if (likeStatus == false) {
      this.service.likeComment(commentId).subscribe(
        res => {
          if (res.errorCode == 0) {
            this.handleChangingLikeCommentOnSurface(index, 'liked', type, deepIndex)
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    } else if (likeStatus == true) {
      this.service.unlikeComment(commentId).subscribe(
        res => {
          if (res.errorCode == 0) {
            this.handleChangingLikeCommentOnSurface(index, 'disLiked', type, deepIndex)
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    }
  }

  handleChangingLikeCommentOnSurface(index, likedSit, type, deepIndex) {
    if (type == 'surface') {
      if (likedSit == 'liked') {
        this.Comments[index].iLikedComment = true
        this.Comments[index].likesCount = this.Comments[index].likesCount + 1
      } else if (likedSit == 'disLiked') {
        this.Comments[index].iLikedComment = false
        this.Comments[index].likesCount = this.Comments[index].likesCount - 1
      }
    } else if (type == 'deep') {
      if (likedSit == 'liked') {
        this.Comments[index].subComments[deepIndex].iLikedComment = true
        this.Comments[index].subComments[deepIndex].likesCount = this.Comments[index].subComments[deepIndex].likesCount + 1
      } else if (likedSit == 'disLiked') {
        this.Comments[index].subComments[deepIndex].iLikedComment = false
        this.Comments[index].subComments[deepIndex].likesCount = this.Comments[index].subComments[deepIndex].likesCount - 1
      }
    }
  }

  // SlideSettings
  slideConfig() {
    if (this?.app?.getUserLanguage() == 'ar') {
      this.slideConfigureForDoctor.rtl = true
    }
  }

  removeParamsFromUrl() {
    this.Router.navigate([], {
      queryParams: {
        'feedId': null,
      },
      queryParamsHandling: 'merge'
    });
  }

  addParamsToUrl() {
    this.Router.navigate([], {
      queryParams: {
        'feedId': this?.postDetails?.postId,
      },
      queryParamsHandling: 'merge'
    });
  }

  scrollDownMainComments(): void {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (this.mainCommentsScroll && this.mainCommentsScroll.nativeElement) {
      const scrollContainer = this.mainCommentsScroll.nativeElement;
      const endScrollTop = scrollContainer.scrollHeight;

      if (scrollContainer.scrollTop < endScrollTop) {
        scrollContainer.scrollTo({
          top: endScrollTop,
          behavior: 'smooth'
        });
      }
    }
  }

  scrollTopMainComments(): void {
    if (this.mainCommentsScroll && this.mainCommentsScroll.nativeElement) {
      const scrollContainer = this.mainCommentsScroll.nativeElement;

      if (scrollContainer.scrollTop > 0) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  }

  notLoggedInDialog() {
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '350px',
      data: {},
    });
    dialogRef.afterClosed().subscribe(res => {
    });
  }

  urlClicked(url) {
    window.open(url)
  }
  
  urlData = null
  urlChangeInput() {
    const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
    setTimeout(async () => {
      if (urlPattern.test(this?.postDetails?.postMedia[0]?.mediaFilePath)) {
        await this.service.getLinkPreviewData(this?.postDetails?.postMedia[0]?.mediaFilePath).subscribe(
          res => {
            const resData: any = res
            if (resData) {
              this.urlData = res
            } else {
              if (this?.app?.getUserLanguage() == 'en') {
                this.toaster.error("Invalid Link");
              } else if (this?.app?.getUserLanguage() == 'ar') {
                this.toaster.error("رابط غير صالح");
              }
            }
          }
        )
      }
    }, 300);
  }


  routeToDocProfile(doc) {
    let docObj = {
      fullName: doc?.creatorName,
      speciality: doc?.creatorSpeciality,
      id: doc?.hcpRequestId,
    }
    this.app.routeToDoctorProfile(docObj)
  }

}
